import React, { Component } from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import { ControlWrapperExtended as ControlWrapper } from './../ControlWrapper/ControlWrapper'
import CheckboxIcon from './CheckboxIconSvg'

const styles = {
  input: {
    height: 40,
    paddingLeft: 22,
    paddingRight: 22,
    borderRadius: 2,
    border: '1px solid #dee1e5',
    backgroundColor: 'white',
    width: 358,
    boxSizing: 'border-box',
    color: '#858585',
  },
}

class CheckboxControl extends Component {

  render = () => {
    const {
      placeholder,
      classes,
      disabled,
      type,
      style,
      ...otherProps } = this.props

    return <ControlWrapper
      icon={<CheckboxIcon />}
      {...otherProps}
    >
      <input
        type="checkbox"
        className={classes.input}
        checked
        disabled
      />
    </ControlWrapper>
  }
}

export default injectStyles(styles)(CheckboxControl)



// WEBPACK FOOTER //
// ./src/modules/CheckboxControl/CheckboxControl.js